import { Link } from "react-router-dom";
import { usePageTitle } from "@/lib/title";

export function NotFoundPage() {
  usePageTitle("Page not found");
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-5 text-center">
      <img src="/logo.svg" alt="" width={48} height={48} className="rounded-xl" />
      <h1 className="text-2xl font-semibold">That page does not exist.</h1>
      <p className="max-w-md text-ink-500">
        The link may be out of date, or the record may have been removed.
      </p>
      <Link to="/app" className="btn btn-primary">
        Back to the dashboard
      </Link>
    </div>
  );
}
